import { StringUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { ImageElement } from "./ImageElement";
import { StageController } from "../../StageController";
import { BaseElement } from "./BaseElement";
import { StyleManager } from "../../Managers/StyleManager";
import { ParticleStyle } from "../Styles/ParticleStyle";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../../Utils/FrameTimer";
import { CustomUtils } from "../../../Utils/CustomUtils";
import { Tweens } from "../../Effects/Tweens";
import Power4 = gsap.Power4;
import TweenLite = gsap.TweenLite;
import TweenMax = gsap.TweenMax;

// TODO add comments
@engineComponent(ComponentTypes.DisplayObject)
export class ParticleElement extends BaseElement {
    // handle definition for particles
    private _style: ParticleStyle;
    private _styleName: string;
    //  holds particles in pool and reused them
    private _pool: Array<ImageElement>;
    // timer for add particles
    private _timer: FrameTimerEventEmitter;

    private _stopping: boolean;
    private _stop: boolean;
    private _emitOnce: boolean;
    private _startType: string;

    private _blendMode: number;

    private _allowedPoints: Array<any>;

    private _points: Array<any>;

    constructor() {
        super();

        this._pool = [];

        this._timer = CreateFrameTimer("particleTimer");
        this._timer.on(FrameTimerEvents.Complete, this.addParticles.bind(this));

        this._stopping = false;
        this._stop = true;
        this._emitOnce = false;
        this._startType = "";
        this.visible = false;

        this._allowedPoints = [];
        this._points = [];
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        // if(node.hasAttribute(ParticleElementAttributes.IMAGE_MASK)){
        //
        //     let imageElement: ImageElement = new ImageElement(StageController.getTextureByResourceId(node.getAttribute('ImageMask')));
        //     let ble = StageController.Renderer.plugins.extract;
        //     let info =ble.pixels(imageElement)
        //     let countX = 0;
        //     let width = imageElement.width;
        //     let height = imageElement.height;
        //     let countY = 0;
        //     let counterX = 0 ;
        //     let counterY = 0 ;
        //     let multiplier = 0.00392156862;
        //     let alpha = 1;
        //     let r:Number;
        //     let g:Number;
        //     let b:Number;
        //     let color:number;
        //
        //     for (let i = 0; i < info.length; i += 4) {
        //         if(info[i] !=0
        //             || info[i+1]!=0
        //             || info[i+2]!=0
        //             || info[i+3]!=0){
        //             alpha = info[i+3]/255
        //
        //             r=Math.round((1 - alpha) * 255 + alpha * info[i])/255
        //             g=Math.round((1 - alpha) * 255 + alpha * info[i+1])/255
        //             b=Math.round((1 - alpha) * 255 + alpha * info[i+2])/255
        //
        //             color = PIXI.utils.rgb2hex([r,g,b])
        //             this._allowedPoints.push([countX,countY,color])
        //         }
        //         countX++;
        //
        //         if(countX == width){
        //             counterY++;
        //             countX = 0;
        //             countY++;
        //         }
        //     }
        // }

        if (node.hasAttribute(ParticleElementAttributes.BLEND_MODE)) {
            this._blendMode = parseInt(node.getAttribute(ParticleElementAttributes.BLEND_MODE));
        }

        if (node.hasAttribute(ParticleElementAttributes.STYLE) || node.hasAttribute(ParticleElementAttributes.STYLE2)) {
            if (node.hasAttribute(ParticleElementAttributes.STYLE)) {
                this._style = <ParticleStyle>StyleManager.Styles[node.getAttribute(ParticleElementAttributes.STYLE)];
            } else {
                this._style = <ParticleStyle>StyleManager.Styles[node.getAttribute(ParticleElementAttributes.STYLE2)];
            }

            this._styleName = this._style.name;

            this.createParticles(node);
        }

        // if(node.nodeName=='Logoo' && node.hasAttribute('Case')){
        //     if(node.getAttribute('Case')){
        //
        //         for (let i:number = 0; i < this._pool.length; i++) {
        //             let imageElement: ImageElement = this._pool[i];
        //             let particleLife: number = Math.floor(Math.random() * (this._style.maxLife - this._style.minLife)) + this._style.minLife;
        //
        //             this.addPathBehaviour(imageElement, particleLife,node.getAttribute('Case'));
        //         }
        //     }
        // }
    }

    updateByNode(node: Element): void {
        // if(node.nodeName=='DustFireBig2'){
        //     console.log(node)
        // }

        super.updateByNode(node);

        if (
            node.hasAttribute(ParticleElementAttributes.START) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.START))
        ) {
            if (node.hasAttribute(ParticleElementAttributes.EMIT_ONCE)) {
                this._emitOnce = StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.EMIT_ONCE));
            }

            if (node.hasAttribute(ParticleElementAttributes.START_TYPE)) {
                this._startType = node.getAttribute(ParticleElementAttributes.START_TYPE);
            }

            this.start(this._emitOnce, this._startType);
        }

        if (
            node.hasAttribute(ParticleElementAttributes.STOPPING) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOPPING))
        ) {
            this.stopping();
        }

        if (
            node.hasAttribute(ParticleElementAttributes.STOP) &&
            StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOP))
        ) {
            this.stop();
        }
    }

    start(emitOnce: boolean = false, startType: string = ""): void {
        this.visible = true;
        this._emitOnce = emitOnce;
        this._startType = startType;
        this._stopping = emitOnce;
        this._stop = false;
        if (!this._emitOnce) {
            this._timer.start(this._style.time);
            if (this._startType === "now") {
                this.addParticles();
            }
        } else {
            this.addParticles();
        }
    }

    stopping(): void {
        this._stopping = true;
    }

    stop(): void {
        this._stopping = false;
        this._stop = true;
        this._timer.stop();
        this.visible = false;
        this.removeAllFromPool();
    }

    private createParticles(node?: Element): void {
        if (this._style != null) {
            if (this._style.images != null && this._style.images.length > 0) {
                let elementsCount: number = this._style.calculateElements(node);
                let elementsResources: Array<string> = this.prepareResources(elementsCount);

                for (let i: number = 0; i < elementsCount; i++) {
                    let imageElement: ImageElement = new ImageElement(
                        StageController.getTextureByResourceId(elementsResources[i]),
                    );
                    let particleLife: number =
                        Math.floor(Math.random() * (this._style.maxLife - this._style.minLife)) + this._style.minLife;

                    this.setupParticle(imageElement);
                    this.setupPosition(imageElement);

                    this.addPathBehaviour(imageElement, particleLife, "", i);
                    this.addScaleBehaviour(imageElement, particleLife);
                    this.addRotationBehaviour(imageElement, particleLife);
                    this.addAlphaBehaviour(imageElement, particleLife);
                    // TODO: colorBehavior, gravityBehavior

                    this.addChild(imageElement);
                    this._pool.push(imageElement);
                }
            }
        }
    }

    private prepareResources(count: number): Array<string> {
        let resources: Array<string> = [];
        for (let i: number = 0; i < count; i++) {
            resources.push(this._style.images[Math.floor(Math.random() * this._style.images.length)]);
        }
        return resources;
    }

    private setupParticle(imageElement: ImageElement): void {
        imageElement.visible = false;
        imageElement.usedInPool = false;

        if (this._blendMode != null) {
            imageElement.blendMode = CustomUtils.getBlendMode(this._blendMode);
        }

        if (this._style.scale != 1) {
            imageElement.scale.x = this._style.scale;
            imageElement.scale.y = this._style.scale;
        }
    }

    private setupPosition(imageElement: ImageElement): void {
        imageElement.pivot.x = imageElement.width / 2;
        imageElement.pivot.y = imageElement.height / 2;

        switch (this._style.positionZone.type) {
            case ParticleStyle.ZoneRectangle:
                imageElement.x = parseInt(
                    (this._style.positionZone.x + Math.random() * this._style.positionZone.width).toFixed(0),
                );
                imageElement.y = parseInt(
                    (this._style.positionZone.y + Math.random() * this._style.positionZone.height).toFixed(0),
                );

                // if(this._allowedPoints.length){
                //     let idPoint = Math.floor(Math.random()*this._allowedPoints.length)
                //
                //     imageElement.x = this._allowedPoints[idPoint][0];
                //     imageElement.y = this._allowedPoints[idPoint][1];
                //     imageElement.tint = this._allowedPoints[idPoint][2];
                // }
                break;
            case ParticleStyle.ZoneLine:
                // TODO
                break;
            case ParticleStyle.ZoneCircle:
            case ParticleStyle.ZoneEllipse:
                let originX = this._style.positionZone.x;
                let originY = this._style.positionZone.y;

                let radianDegrees = Math.floor(Math.random() * this._style.positionZone.angle);
                let radian = this.degrees2radians(radianDegrees);

                this._style.positionZone.currentAngle = radian;

                if (this._style.positionZone.positionRadius > 0) {
                    let randomRadius = Math.floor(Math.random() * this._style.positionZone.positionRadius);

                    originX = Math.floor(this._style.positionZone.x + randomRadius * Math.cos(radian));
                    originY = Math.floor(this._style.positionZone.y + randomRadius * Math.sin(radian));
                    this._style.positionZone.currentAngle = radian;
                }

                // if(this._style.positionZone.showAngle!=360){
                //
                //     let allowedAngles: Array<any> = [];
                //     let partAngle = this._style.positionZone.showAngle;
                //     let low: number;
                //     let high: number;
                //
                //     for(let i=0; i<360/partAngle; i++){
                //
                //         let bla = partAngle
                //         allowedAngles.push([i*bla,(i+1)*bla])
                //     }
                //
                //     allowedAngles = [
                //         [0,59],
                //         // [60,119],
                //         [120,179],
                //         // [180,239],
                //         [240,299],
                //         // [300,359],
                //     ];
                //
                //     let id =  Math.floor((Math.random() * 3))
                //
                //     // console.log(allowedAngles[id][0])
                //
                //     low = allowedAngles[id][0]
                //     high = allowedAngles[id][1]
                //
                //     let radianDegrees = Math.floor((Math.random() * (high-low))+ low);
                //     radian = this.degrees2radians(radianDegrees);
                //     this._style.positionZone.currentAngle = radian;
                // }

                imageElement.x = originX;
                imageElement.y = originY;

                // TODO: positionZone,
                break;
        }
    }

    private addPathBehaviour(imageElement: ImageElement, life: number, cases?: string, countImages?: number): void {
        if (this._style.pathValues != null) {
            let points: Array<Object> = [];
            for (let i: number = 0; i < this._style.pathValues.length; i++) {
                if (
                    this._style.pathValues[i] != null &&
                    this._style.pathValues[i].x != null &&
                    this._style.pathValues[i].y != null
                ) {
                    let valueX: number = this._style.pathValues[i].x;
                    let valueY: number = this._style.pathValues[i].y;
                    if (this._style.pathValues[i].randomX != null) {
                        valueX =
                            Math.floor(
                                Math.random() * (this._style.pathValues[i].randomX - this._style.pathValues[i].x),
                            ) + this._style.pathValues[i].x;
                    }
                    if (this._style.pathValues[i].randomY != null) {
                        valueY =
                            Math.floor(
                                Math.random() * (this._style.pathValues[i].randomY - this._style.pathValues[i].y),
                            ) + this._style.pathValues[i].y;
                    }
                    points.push({ x: imageElement.x + valueX, y: imageElement.y + valueY });
                }
            }

            if (countImages) {
                this._points.push(points);
            }

            if (points.length > 2) {
                Tweens.positionTween(imageElement, {
                    bezier: {
                        values: points,
                    },
                    tweenX: [imageElement.x, imageElement.x],
                    tweenY: [imageElement.y, imageElement.y],
                    tweenDuration: life,
                    paused: false,
                    callbackFunction: this.removeFromPool,
                    callbackParams: [imageElement],
                    callbackScope: null,
                });
            } else if (points.length === 2) {
                Tweens.positionTween(imageElement, {
                    tweenX: [points[0]["x"], points[1]["x"]],
                    tweenY: [points[0]["y"], points[1]["y"]],
                    tweenDuration: life,
                    paused: false,
                    callbackFunction: this.removeFromPool,
                    callbackParams: [imageElement],
                    callbackScope: null,
                });
            }
        }

        // if(this._allowedPoints.length){
        //     let idPoint = Math.floor(Math.random()*this._allowedPoints.length)
        //     let points: Array<Object> = [];
        //
        //
        //     if(cases=='Random'){
        //         let finalX= imageElement.x + Math.floor((Math.random()*200) - 100)
        //         let finalY= imageElement.y + Math.floor((Math.random()*200) - 100)
        //         points.push({x:finalX,y:finalY})
        //
        //         finalX= finalX + Math.floor((Math.random()*300) - 150)
        //         finalY= finalY + Math.floor((Math.random()*300) - 150)
        //         points.push({x:finalX,y:finalY})
        //
        //         Tweens.removeTweens(imageElement,'position')
        //         // Tweens.removeTweenFromRegistry(imageElement.uid,'position')
        //         Tweens.positionTween(imageElement, {
        //             bezier: {
        //                 values: points
        //             },
        //             // tweenX: [imageElement.x,finalX],
        //             tweenX: [imageElement.x,imageElement.x],
        //             // tweenY: [imageElement.y,finalY],
        //             tweenY: [imageElement.y,imageElement.y],
        //             tweenDuration: life,
        //             paused: false,
        //             callbackFunction: this.removeFromPool, callbackParams: [imageElement], callbackScope: null,
        //             tweenLoop: false,
        //         });
        //
        //     }else{
        //
        //         // let idPoint = Math.floor(Math.random()*this._allowedPoints.length)
        //         //
        //         // imageElement.x = this._allowedPoints[idPoint][0];
        //         // imageElement.y = this._allowedPoints[idPoint][1];
        //         // imageElement.tint = this._allowedPoints[idPoint][2];
        //
        //         // Tweens.removeTweens(imageElement,'position')
        //         // Tweens.positionTween(imageElement, {
        //         //     tweenX: [imageElement.x,imageElement.x],
        //         //     tweenY: [imageElement.y,imageElement.y],
        //         //     tweenDuration: life,
        //         //     paused: false,
        //         //     callbackFunction: this.removeFromPool, callbackParams: [imageElement], callbackScope: null,
        //         //     tweenLoop: false
        //         // });
        //     }
        //
        //
        // }

        if (this._style.positionZone.type == "Circle" || this._style.positionZone.type == "Ellipse") {
            let radian: number;
            let startX = imageElement.x;
            let startY = imageElement.y;

            let radius = this._style.positionZone.radius;

            if (this._style.positionZone.randomPositionAngle) {
                let radianDegrees = Math.floor(Math.random() * this._style.positionZone.angle);
                radian = this.degrees2radians(radianDegrees); /** 180/math.pi robilo tiez cool vec **/
            } else {
                radian = this._style.positionZone.currentAngle;
            }

            // Parcialne delenie podla uhla

            // if(this._style.positionZone.radius>100){
            //     let randomAngle= Math.floor((Math.random() * 6));
            //     let angle:number = 60;
            //
            //     let allowedAngles: Array<any> = [];
            //
            //     let low: number;
            //     let high: number;
            //
            //     allowedAngles = [
            //         [0,59],
            //         // [60,119],
            //         [120,179],
            //         // [180,239],
            //         [240,299],
            //         // [300,359],
            //     ];
            //
            //     let id =  Math.floor((Math.random() * 3))
            //
            //     // console.log(allowedAngles[id][0])
            //
            //     low = allowedAngles[id][0]
            //     high = allowedAngles[id][1]
            //
            //     let radianDegrees = Math.floor((Math.random() * (high-low))+ low);
            //     radian = this.degrees2radians(radianDegrees);
            //
            //     // Parcialne delenie podla uhla
            // }

            if (this._style.positionZone.showAngle < 360) {
                radian = this._style.positionZone.currentAngle;
            }

            if (this._style.positionZone.minRadius != radius) {
                radius = radius - this._style.positionZone.minRadius;
                radius = Math.floor(Math.random() * radius + this._style.positionZone.minRadius);
            }

            let xfinal = Math.floor(imageElement.x + radius * Math.cos(radian));
            let yfinal = Math.floor(imageElement.y + radius * Math.sin(radian));

            if (this._style.positionZone.innerRadius != 0) {
                let allowedRadius = this._style.positionZone.innerRadius;

                if (this._style.positionZone.positionRadius > 0) {
                    //doladit
                    allowedRadius = this._style.positionZone.positionRadius - this._style.positionZone.innerRadius;
                }

                startX = imageElement.x + allowedRadius * Math.cos(radian);
                startY = imageElement.y + allowedRadius * Math.sin(radian);
            }
            Tweens.positionTween(imageElement, {
                tweenX: [startX, xfinal],
                tweenY: [startY, yfinal],
                tweenDuration: life,
                paused: false,
                callbackFunction: this.removeFromPool,
                callbackParams: [imageElement],
                callbackScope: null,
            });
        }

        if (this._style.positionZone.type == "Ellipse") {
            let aWidth = 300;
            let bHeight = -100;
            let radian: number;

            let xfinal: number;
            let yfinal: number;

            let angle = "<-180;180>";

            let radianDegrees = Math.floor(Math.random() * 70 - 35);
            radian = this.degrees2radians(radianDegrees);

            xfinal = aWidth * Math.cos(radian);
            yfinal = bHeight * Math.sin(radian);

            // console.log(xfinal)
            // console.log(yfinal)

            Tweens.positionTween(imageElement, {
                tweenX: [imageElement.x, xfinal],
                tweenY: [imageElement.y, yfinal],
                tweenDuration: life,
                paused: false,
                callbackFunction: this.removeFromPool,
                callbackParams: [imageElement],
                callbackScope: null,
            });
        }

        // if(this.name='Logoo'){
        // console.log(Tweens.getRegisteredTweens())
        // }
    }

    private addScaleBehaviour(imageElement: ImageElement, life: number): void {
        if (this._style.scaleValues != null || this._style.scaleValues.length != 0) {
            let scalePoints: Array<PIXI.Point> = [];
            for (let i: number = 0; i < this._style.scaleValues.length; i++) {
                let scaleValue: number;
                if (this._style.scaleValues[i].length > 1) {
                    scaleValue = parseFloat(
                        (
                            Math.random() * (this._style.scaleValues[i][1] - this._style.scaleValues[i][0]) +
                            this._style.scaleValues[i][0]
                        ).toFixed(1),
                    );
                } else {
                    scaleValue = this._style.scaleValues[i][0];
                }

                // if(this._style.scaleValues[i].randomX != null) {
                //     scaleValue = Math.floor(Math.random() * (this._style.scaleValues[i].randomX - this._style.scaleValues[i].x)) + this._style.scaleValues[i].x;
                // }

                scalePoints.push(new PIXI.Point(scaleValue, scaleValue));
            }

            Tweens.scaleTween(imageElement, {
                tweenValues: scalePoints,
                tweenDuration: life,
                paused: false,
            });
        } else {
            console.log(this.scale);
            console.log(this._style.scale);
        }
    }

    private addRotationBehaviour(imageElement: ImageElement, life: number): void {
        if (this._style.rotationValues != null && this._style.rotationValues.length > 1) {
            Tweens.rotationTween(imageElement, {
                degrees: [this._style.rotationValues[0], this._style.rotationValues[1]],
                tweenDuration: life,
                paused: false,
            });
        }
    }

    private addAlphaBehaviour(imageElement: ImageElement, life: number): void {
        if (this._style.alphaValues != null) {
            let alphas: Array<number> = [];
            for (let i: number = 0; i < this._style.alphaValues.length; i++) {
                alphas.push(this._style.alphaValues[i]);
            }
            Tweens.alphaTween(imageElement, {
                alphas: alphas,
                tweenDuration: life,
                paused: false,
            });
        }
    }

    private addParticles(): void {
        if (!this._stop) {
            this.getFromPool();

            if (!this._stopping) {
                this._timer.start(this._style.time);
            }
        }
    }

    private getFromPool(): void {
        this._pool.sort(function () {
            return 0.5 - Math.random();
        });

        let counter: number = 0;
        for (let i: number = 0; i < this._pool.length; i++) {
            if (counter === this._style.count) {
                return;
            }
            if (!this._pool[i].usedInPool) {
                this._pool[i].usedInPool = true;
                this._pool[i].visible = true;
                counter++;
                Tweens.restartTweens(this._pool[i].uid);
            }
        }
    }

    private removeFromPool(imageElement: ImageElement): void {
        imageElement.visible = false;
        imageElement.usedInPool = false;
    }

    private removeAllFromPool(): void {
        for (let i: number = 0; i < this._pool.length; i++) {
            // Tweens.removeTweens(this._pool[i]);
            this._pool[i].visible = false;
            this._pool[i].usedInPool = false;
            // TODO stop all tweens
        }
    }

    public degrees2radians(degrees: number): number {
        return degrees * (Math.PI / 180);
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return ParticleElement
     */
    clone(): ParticleElement {
        let element: ParticleElement = new ParticleElement();
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        let node: Element = document.createElement("particle");
        node.setAttribute("Style2", this._styleName);
        element.create(node);
        element._markAsCloned(); // must be called last before return!
        return element;
    }
}

export const ParticleElementAttributes = {
    /**
     * Blend mode for animation.
     * Bleding modes:
     *   0 = NORMAL;
     *   1 = ADD;
     *   2 = MULTIPLY;
     *   3 = SCREEN;
     *   4 = OVERLAY;
     *   5 = DARKEN;
     *   6 = LIGHTEN;
     *   7 = COLOR_DODGE;
     *   8 = COLOR_BURN;
     *   9 = HARD_LIGHT;
     *   10 = SOFT_LIGHT;
     *   11 = DIFFERENCE;
     *   12 = EXCLUSION;
     *   13 = HUE;
     *   14 = SATURATION;
     *   15 = COLOR;
     *   16 = LUMINOSITY;
     * @property BlendMode
     * @type number
     * @default null
     */
    BLEND_MODE: "BlendMode",
    SPEED: "Speed",
    EMIT_ONCE: "EmitOnce",
    START_TYPE: "StartType",
    // Tweens used in BaseElementParticle
    ALPHA_TWEEN: "AlphaTween",
    ALPHA_TWEEN_EASE: "AlphaTweenEase",
    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",

    POSITION_TWEEN_X: "PositionTweenX",
    POSITION_TWEEN_Y: "PositionTweenY",
    POSITION_TWEEN_EASE: "PositionTweenEase",
    POSITION_TWEEN_DURATION: "PositionTweenDuration",
    POSITION_TWEEN_POSITION: "PositionTweenPosition",
    POSITION_TWEEN_POSITION_VALUE: {
        ABSOLUTE: "absolute",
        RELATIVE: "relative",
    },

    ROTATION_TWEEN: "RotationTween",
    ROTATION_TWEEN_EASE: "RotationTweenEase",
    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
    ROTATION_TWEEN_DELAY: "RotationTweenDelay",

    SCALE_TWEEN: "ScaleTween",
    SCALE_TWEEN_EASE: "ScaleTweenEase",
    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
    /**
     * Style define animation. You can use one style on more than one place.
     * Style for ParticleElement has to be instance of ParticleStyle.
     * @property Style
     * @type string
     * @default null
     */
    STYLE: "Style",
    STYLE2: "Style2",
    EXTEND_STYLE: "ExtendStyle",
    START: "Start",
    STOPPING: "Stopping",
    STOP: "Stop",
    /**
     * Tint of animation. Hex color which colorize movie clip.
     * @property Tint
     * @type string
     * @default null
     */
    TINT: "Tint",
    ATTR_COUNT: "Count",
    ATTR_TIME: "Time",
    ATTR_MIN: "Min",
    ATTR_MAX: "Max",
    ATTR_FROM_FRAME: "FromFrame",
    ATTR_IMAGES: "Images",
    ATTR_TYPE: "Type",
    ATTR_X: "X",
    ATTR_Y: "Y",
    ATTR_RANDOM_X: "RandomX",
    ATTR_RANDOM_Y: "RandomY",
    ATTR_WIDTH: "Width",
    ATTR_HEIGHT: "Height",
    ATTR_RADIUS: "Radius",
    ATTR_POSITION_RADIUS: "PositionRadius",
    ATTR_RANDOM_POSITION_ANGLE: "RandomPositionAngle",
    ATTR_MIN_RADIUS: "MinRadius",
    ATTR_INNER_RADIUS: "InnerRadius",
    ATTR_ANGLE: "Angle",
    ATTR_SHOW_ANGLE: "ShowAngle",
    ATTR_VALUES: "Values",
    ATTR_VALUE: "Value",
    IMAGE_MASK: "ImageMask",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Graphics/ParticleElement.ts
 **/